import React from "react";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import StorageRoundedIcon from "@mui/icons-material/StorageRounded";
import { brand } from "../../../theme/businessFlowsTheme";

export const menuProps = {
  PaperProps: { className: "bfx", sx: { borderRadius: 3, border: `1px solid ${brand.line}`, maxHeight: 360 } },
};

// Which customer database a configuration screen applies to. Configuration is
// held per database, so this choice is the first thing an admin makes.
export default function DatabaseSelect({ databases = [], labelFor = (name) => name, value, onChange, sx }) {
  return (
    <TextField
      select
      size="small"
      label="Database"
      // The theme makes text fields full width; here it sits beside a heading.
      fullWidth={false}
      value={value || ""}
      onChange={(event) => onChange(event.target.value)}
      SelectProps={{ MenuProps: menuProps }}
      sx={{ width: 240, flexShrink: 0, ...sx }}
    >
      {databases.map((name) => (
        <MenuItem key={name} value={name}>
          <Stack direction="row" spacing={1} alignItems="center">
            <StorageRoundedIcon fontSize="small" sx={{ color: brand.signalDeep }} />
            <span>{labelFor(name)}</span>
          </Stack>
        </MenuItem>
      ))}
    </TextField>
  );
}
